var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row row--grid" },
      _vm._l(_vm.posts, function(item) {
        return _c(
          "a",
          {
            staticClass:
              "col col-sm-12 col-md-12 col-lg-4 m-news_teasers__item",
            attrs: { href: item.link }
          },
          [
            _c(
              "span",
              {
                staticClass:
                  "m-news_teasers__item-date title--small font-color-primary"
              },
              [_vm._v(_vm._s(_vm.dateToLocale(item.date)))]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "h4 m-news_teasers__item-title" }, [
              _c("strong", [_vm._v(_vm._s(item.post_title))])
            ]),
            _vm._v(" "),
            item.lead
              ? _c("p", { staticClass: "m-news_teasers__item-lead" }, [
                  _vm._v("\n        " + _vm._s(item.lead) + "\n      ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("v-icon", { attrs: { name: "arrow-right-color" } })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "action__container action__container--center" }, [
      _vm.lexicon.hasOwnProperty("show_more") && !_vm.no_more_posts
        ? _c(
            "button",
            {
              staticClass: "action action--button",
              on: { click: _vm.loadMore }
            },
            [
              _c("span", { staticClass: "action__text" }, [
                _vm._v(_vm._s(_vm.lexicon.show_more))
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }